module.exports = __webpack_public_path__ + "img/range4.06623fe9.png";